import { Box } from '@mui/material';
import DialogBody from 'components/dialog/DialogBody';
import DialogButtons from 'components/dialog/DialogButtons';
import DialogContent from 'components/dialog/DialogContent';
import DialogTitle from 'components/dialog/DialogTitle';
import { memo, ReactNode } from 'react';

interface ISendMailDialogProps {
  contents: string;
  title?: string;
  children: ReactNode;
}
function SendMailDialog({ title = '', contents, children }: ISendMailDialogProps): JSX.Element {
  return (
    <DialogContent width={{ desktop: 500 }} height={{ desktop: 'fit-content' }}>
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogBody style={{ overflowX: 'hidden', overflowY: 'scroll !important' }}>
        <Box sx={{ fontSize: 18, fontWeight: 700, mb: 3 }}>{contents}</Box>
      </DialogBody>
      <DialogButtons justifyContent="space-evenly" marginTop="0px">
        {children}
      </DialogButtons>
    </DialogContent>
  );
}

export default memo(SendMailDialog);
